export class LogicFilter {
  constructor() {
    const data = arguments[0] || {};
    this.id = data.id;
    this.name = data.name || '';
    this.name_l10n = data.name_l10n || {};
    this.events_custom_logic_groups_id = data.events_custom_logic_groups_id || null;
    this.events_custom_logic_filters_definitions_id = data.events_custom_logic_filters_definitions_id || null;
    this.events_custom_logic_filters_definitions_options_id = data.events_custom_logic_filters_definitions_options_id || null;
    this.system_name = data.system_name || null;
    this.value = data.value || null;
    this.options = data.options || [];
    this.selectedOption = data.selectedOption || null;
  }

  updateValues(selectedFilter, selectedOption = null) {
    this.name = selectedFilter.name;
    this.name_l10n = selectedFilter.name_l10n;
    this.events_custom_logic_filters_definitions_id = selectedFilter.id;
    this.system_name = selectedFilter.system_name;
    this.options = selectedFilter.options || [];
    this.selectedOption = selectedOption;
    if (this.selectedOption) {
      if (this.selectedOption.id) {
        this.events_custom_logic_filters_definitions_options_id = this.selectedOption.id;
      } else if (this.selectedOption.value) {
        this.value = this.selectedOption.value;
      }
    }
  }

  logicResultForRecapResponse(recapResponse) {
    if (!recapResponse || !recapResponse.logicFiltersData || !this.events_custom_logic_filters_definitions_id) {
      // Don't display if we for some reason have no data to check against
      return false;
    }
    const data = recapResponse.logicFiltersData;
    const keys = Object.keys(data);
    return keys.some((key) => {
      if (String(key) === String(this.events_custom_logic_filters_definitions_id)) {
        const values = data[key];
        if (this.system_name) {
          // Handle any custom logic filters
          if (this.system_name === 'finance_schema') {
            const filterValues = this.value?.split(',,,');
            if (filterValues && filterValues.length) {
              const ids = [];
              for (const val of filterValues) {
                const [id] = val.split('|||');
                if (id) {
                  ids.push(String(id));
                }
              }
              let result = true;
              for (let i = 0; i < ids.length; i++) {
                // Ensure that the entire hierarchy of filter values matches the hierarchy of data
                // If we run out of filter values but there's still more data, this is still considered a good result
                // because we've satisfied the logic filter condition
                const idVal = ids[i];
                const dataVal = values[i];
                if (!dataVal || String(idVal) !== String(dataVal)) {
                  result = false;
                }
              }
              return result;
            }
          } else {
            return false;
          }
        }
        if (this.events_custom_logic_filters_definitions_options_id) {
          // Check if it's the correct option ID
          const option = this.options.find(opt => String(opt.id) === String(this.events_custom_logic_filters_definitions_options_id));
          return values.some(val => String(val) === String(option.value));
        }

        // Check if one of the values match
        return values.some(val => String(val) === String(this.value));
      }
      return false;
    });
  }
}

export default LogicFilter;
